import React, { useCallback } from 'react';
import { StyleSheet, View } from 'react-native';
import { useFocusEffect } from '@react-navigation/native';
import {
  ListActionSwitch,
  LoadingPlaceholder,
  theme,
} from '@sweetgreen/garnish';

import { useUpdateUseCreditMutation } from '@order/graphql';
import { useCustomerCredit } from '@order/hooks';
import { useLocalizationContext } from '@order/Localization';

export const CreditSelector = () => {
  const { t, formatPrice } = useLocalizationContext();
  const [{ fetching }, updateUseCredit] = useUpdateUseCreditMutation();
  const { availableCredit, useCredit, isLoadingCredits, refetchCredits } =
    useCustomerCredit();
  const isUseCreditLoading = fetching || isLoadingCredits;

  useFocusEffect(useCallback(refetchCredits, [refetchCredits]));

  // ─── Update Use Credit ───────────────────────────────────────────────
  const handleOnChange = useCallback(
    async (input: boolean) => {
      await updateUseCredit({ useCredit: input });
      refetchCredits();
    },
    [updateUseCredit, refetchCredits],
  );

  if (!isLoadingCredits && !availableCredit) return null;

  return (
    <View style={isUseCreditLoading ? styles.loadingPadding : styles.padding}>
      {isUseCreditLoading ? (
        <LoadingPlaceholder palette="darkGray" rows={1} rowHeight={52} />
      ) : (
        <ListActionSwitch
          iconName="IconSweetgreen"
          title={t('checkout.use-credit')}
          value={useCredit}
          text={formatPrice(availableCredit, 'USD')}
          onChange={handleOnChange}
        />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  padding: {
    paddingHorizontal: theme.spacing.medium,
  },
  loadingPadding: {
    padding: theme.spacing.medium,
  },
});
